{
    "CallControlMcError": "Er is een fout opgetreden bij het proberen verbinding te maken met",
    "CallControlActionError": "Er is een fout opgetreden bij het uitvoeren van de actie",
    "CallControlCompleteTransferError": "Er is een fout opgetreden bij het voltooien van de overdracht",
    "CallControlPickupCallError": "Er is een fout opgetreden bij het aannemen van de oproep",
    "CallControlChangingDndError": "Er is een fout opgetreden bij het wijzigen van de NST-status voor",
    "CallControlConnectionUpdate": "Er is een fout opgetreden bij de verbindingsupdate",
    "CallControlDeletePhantom": "Er is een fout opgetreden bij het verwijderen van een fantoomoproep.",
    "CallControlAcdStatusUpdate": "Er is een fout opgetreden in de ACD-statusupdate",
    "CallControlMonitoringActionError": "Er is een fout opgetreden bij het bewaken van actie",
    "CallControlUserInfoMissing": "Gebruikersinfo ontbreekt. Dit kan erop wijzen dat u niet langer bent geverifieerd. Probeer uit en weer in te loggen.",
    "CallControlTelPartDevError": "Telefoonserver, partitie, agent of apparaat waren niet beschikbaar.",
    "NAME": "CallControlErrors",
    "CallControlSetAccountCode": "Er is een fout opgetreden bij het instellen van de accountcode"
}